export default defineNuxtPlugin((nuxtApp) => {
  // Catch dynamic module/chunk loading failures caused by new deployments
  const router = useRouter();

  router.onError((error: any, to) => {
    const isChunkError =
      error?.message?.includes("Failed to fetch dynamically imported module") ||
      error?.message?.includes("Importing a module script failed") ||
      error?.message?.includes("error loading dynamically imported module") ||
      error?.message?.includes("Loading chunk");

    if (isChunkError) {
      const targetUrl = to?.fullPath || window.location.href;
      console.warn(`[Chunk Loader] New deployment detected. Reloading to fetch fresh bundle: ${targetUrl}`);
      
      // Prevent infinite reload loops by checking sessionStorage key
      const reloadKey = `qam_chunk_reload_${targetUrl}`;
      const lastReload = sessionStorage.getItem(reloadKey);
      const now = Date.now();

      if (!lastReload || now - parseInt(lastReload, 10) > 10000) {
        sessionStorage.setItem(reloadKey, String(now));
        window.location.href = targetUrl;
      }
    }
  });
});
